import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils/cn";

export function Forbidden() {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center"
    >
      <h1 className="text-2xl font-semibold">{t("errors.forbiddenTitle")}</h1>
      <p className="text-muted-foreground">{t("errors.forbiddenMessage")}</p>
      <Link to="/dashboard" className={cn(buttonVariants())}>
        {t("errors.backHome")}
      </Link>
    </div>
  );
}
